import Header from "./components/Header";
import { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Outlet,
} from "react-router-dom";
import Home from "./pages/Home";
import Four0Four from "./pages/404";
import About from "./pages/About";
import Projects from "./pages/Projects";
import Footer from "./components/Footer";
import Contact from "./pages/Contact";
import Shares from "./pages/Shares";
import Forum from "./pages/Forum";
import ProjectMisToDo from "./pages/Project_mistodo";
import ProjectChatRivo from "./pages/Project_chatrivo";

//import { PlusOutlined } from "@ant-design/icons";

function App() {
  //cihaz
  const [device, setDevice] = useState(
    window.matchMedia("(max-width: 820px)").matches
      ? "phone"
      : window.matchMedia("(max-width: 1300px)").matches
      ? "tablet"
      : "pc"
  );

  //hangi cihaz
  function handleWindowSizeChange() {
    if (window.innerWidth > 1300) setDevice("pc");
    else if (window.innerWidth > 820) setDevice("tablet");
    else setDevice("phone");
  }

  useEffect(() => {
    window.addEventListener("resize", handleWindowSizeChange);
    return () => {
      window.removeEventListener("resize", handleWindowSizeChange);
    };
  }, []);

  const [menu, setMenu] = useState(false);
  const [current, setCurrent] = useState("");

  return (
    <div
      className="App"
      style={{
        width: "100vw",
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <Router>
        <Routes>
          <Route
            element={
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  minHeight: "100vh",
                }}
              >
                <Header
                  current={current}
                  setCurrent={setCurrent}
                  device={device}
                  menu={menu}
                  setMenu={setMenu}
                />
                <main
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "space-between",
                    minHeight: "100vh",
                  }}
                >
                  <Outlet />
                  <Footer device={device} />
                </main>
              </div>
            }
          >
            <Route
              path="/"
              element={<Home device={device} setCurrent={setCurrent} />}
            />

            <Route
              path="/about"
              element={<About device={device} setCurrent={setCurrent} />}
            />

            <Route
              path="/projects"
              element={<Projects device={device} setCurrent={setCurrent} />}
            />
            <Route
              path="/projects/MisToDo"
              element={<ProjectMisToDo device={device} setCurrent={setCurrent} />}
            />
            <Route
              path="/projects/ChatRivo"
              element={<ProjectChatRivo device={device} setCurrent={setCurrent} />}
            />

            <Route
              path="/shares"
              element={<Shares device={device} setCurrent={setCurrent} />}
            />

            <Route
              path="/forum"
              element={<Forum device={device} setCurrent={setCurrent} />}
            />

            <Route
              path="/contact"
              element={<Contact device={device} setCurrent={setCurrent} />}
            />
            <Route path="*" element={<Four0Four device={device} />} />
          </Route>
        </Routes>
      </Router>
    </div>
  );
}

export default App;
